import { useSelector } from "react-redux"

export const useSelectorCustom = () => {

    const users = useSelector(state => state.auth.users)
    const user_id = useSelector(state => state.auth.user_id)
    const loadingUsers = useSelector(state => state.auth.loadingUsers)

    const visitors = useSelector(state => state.visitor.visitors)
    const loadingVisitors = useSelector(state => state.visitor.loadingVisitors)
    
    const projectTypes = useSelector(state => state.projectType.projectTypes)
    const loadingProjectTypes = useSelector(state => state.projectType.loadingProjectTypes)

    const roles = useSelector(state => state.role.roles)
    const loadingRoles = useSelector(state => state.role.loadingRoles)

    const creativeWork = useSelector(state => state.creative_work.creativeWork)
    const loadingcreativeWork = useSelector(state => state.creative_work.loadingcreativeWork)

    const evaluation = useSelector(state => state.evaluations.evaluation)
    const loadingevaluation = useSelector(state => state.evaluations.loadingevaluation)

    const permissions = useSelector(state => state.role.permissions)
    const loadingpermissions = useSelector(state => state.role.loadingpermissions)

    const evaluationDetails = useSelector(state => state.evaluationDetail.evaluationDetails)
    const loadingevaluationDetails = useSelector(state => state.evaluationDetail.loadingevaluationDetails)

    const evaluationDetailsByReader = useSelector(state => state.evaluationDetail.evaluationDetailsByReader)
    const loadingevaluationDetailsByReader = useSelector(state => state.evaluationDetail.loadingevaluationDetailsByReader)

    const statistics = useSelector(state => state.statistic.statistics)
    const loadingStatistics = useSelector(state => state.statistic.loadingStatistics)
 
    const settings = useSelector(state => state.setting.settings)
    const loadingSettings = useSelector(state => state.setting.loadingSettings)
    const currency = useSelector(state => state.setting.currency)

    const mainPermission = useSelector(state => state.role.mainPermission)
    const loadingMainPermission = useSelector(state => state.role.loadingMainPermission)

    const notifications = useSelector(state => state.notification.notifications)
    const loadingNotifications = useSelector(state => state.notification.loadingNotifications)

    const profileDetails = useSelector(state => state.profile.profileDetails)
    const loadingProfileDetails = useSelector(state => state.profile.loadingProfileDetails)
    

    const warehouses = useSelector(state => state.warehousee.warehouses)
    const loadingWarehouses = useSelector(state => state.warehousee.loadingWarehouses)

    const one_warehouse = useSelector(state => state.warehousee.one_warehouse)
    const loadingOneWarehouses = useSelector(state => state.warehousee.loadingOneWarehouses)

    const products = useSelector(state => state.productt.products)
    const loadingProducts = useSelector(state => state.productt.loadingProducts)
    const productsByZone = useSelector(state => state.productt.productsByZone)
    const loadingProductsByZone = useSelector(state => state.productt.loadingProductsByZone)

    const one_product = useSelector(state => state.productt.one_product)
    const loadingOneProduct = useSelector(state => state.productt.loadingOneProduct)

    const categories = useSelector(state => state.categoriess.categories)
    const sub_categories_by_category = useSelector(state => state.categoriess.sub_categories_by_category)
    const loadingCategories = useSelector(state => state.categoriess.loadingCategories)

    const sub_categories = useSelector(state => state.subCategory.sub_categories)
    const loadingSubCategories = useSelector(state => state.subCategory.loadingSubCategories)

    const projects = useSelector(state => state.projectss.projects)
    const loadingProjects = useSelector(state => state.projectss.loadingProjects)

    const supppliers = useSelector(state => state.supply.supppliers)
    const loadingSupppliers = useSelector(state => state.supply.loadingSupppliers)

    const suppplierss = useSelector(state => state.suppliers.suppplierss)
    const loadingSuppplierss = useSelector(state => state.suppliers.loadingSuppplierss)

    const requests = useSelector(state => state.requestss.requests)
    const loadingRequests = useSelector(state => state.requestss.loadingRequests)

    const orders = useSelector(state => state.orderss.orders)
    const loadingOrders = useSelector(state => state.orderss.loadingOrders)

    const deliveries = useSelector(state => state.delivery.deliveries)
    const loadingDeliveries = useSelector(state => state.delivery.loadingDeliveries)

    const zoneType = useSelector(state => state.zonesType.zoneType)
    const loadingZoneType = useSelector(state => state.zonesType.loadingZoneType)

    const zoneWarehouse = useSelector(state => state.zones.zoneWarehouse)
    const loadingZoneWarehouse = useSelector(state => state.zones.loadingZoneWarehouse)
    const zone = useSelector(state => state.zones.zone)
    const loadingZone = useSelector(state => state.zones.loadingZone)

    const accounts = useSelector(state => state.accountss.accounts)
    const loadingAccounts = useSelector(state => state.accountss.loadingAccounts)
    const statementsByAccount = useSelector(state => state.accountss.statementsByAccount)
    const loadingStatementsByAccount = useSelector(state => state.accountss.loadingStatementsByAccount)
    const dataReport = useSelector(state => state.accountss.dataReport)
    const loadingDataReport = useSelector(state => state.accountss.loadingDataReport)

    const page_list = useSelector(state => state.accountss.page_list)
    const loadingPageList = useSelector(state => state.accountss.loadingPageList)

    const one_account = useSelector(state => state.accountss.one_account)
    const loadingOneAccount = useSelector(state => state.accountss.loadingOneAccount)

    const transactions = useSelector(state => state.transactionss.transactions)
    const loadingTransactions = useSelector(state => state.transactionss.loadingTransactions)
    const page_list_transaction = useSelector(state => state.transactionss.page_list_transaction)
    const loadingPageListTransaction = useSelector(state => state.transactionss.loadingPageListTransaction)

    const statements = useSelector(state => state.statementss.statements)
    const loadingStatements = useSelector(state => state.statementss.loadingStatements)
    const page_list_statement = useSelector(state => state.statementss.page_list_statement)
    const loadingPageListStatement = useSelector(state => state.statementss.loadingPageListStatement)
    const one_statement = useSelector(state => state.statementss.one_statement)
    const loadingOneStatement = useSelector(state => state.statementss.loadingOneStatement)

    const expenses = useSelector(state => state.expensess.expenses)
    const accountDetails = useSelector(state => state.expensess.accountDetails)
    const loadingExpenses = useSelector(state => state.expensess.loadingExpenses)
    const one_expense = useSelector(state => state.expensess.one_expense)
    const loadingOneExpense = useSelector(state => state.expensess.loadingOneExpense)
    const page_list_expenses = useSelector(state => state.expensess.page_list_expenses)
    const loadingPageListExpenses = useSelector(state => state.expensess.loadingPageListExpenses)

    const page_list_scripts_archive = useSelector(state => state.ScriptArchivee.page_list_scripts_archive)
    const loadingPageListScriptsArchive = useSelector(state => state.ScriptArchivee.loadingPageListScriptsArchive)
    const scriptsArchive = useSelector(state => state.ScriptArchivee.scriptsArchive)
    const loadingScriptsArchive = useSelector(state => state.ScriptArchivee.loadingScriptsArchive)
    const oneScriptsArchive = useSelector(state => state.ScriptArchivee.oneScriptsArchive)
    const loadingOneScriptsArchive = useSelector(state => state.ScriptArchivee.loadingOneScriptsArchive)

    const account_types = useSelector(state => state.accountTypees.account_types)
    const loadingAccountTypes = useSelector(state => state.accountTypees.loadingAccountTypes)

    const vcards = useSelector(state => state.vcardsRed.vcards)
    const loadingVcards = useSelector(state => state.vcardsRed.loadingVcards)

    return {
        users,loadingUsers,
        visitors,loadingVisitors,
        projectTypes,loadingProjectTypes,
        roles,loadingRoles,
        creativeWork, loadingcreativeWork,
        evaluation,loadingevaluation,
        permissions,loadingpermissions,
        evaluationDetails,loadingevaluationDetails,
        evaluationDetailsByReader,loadingevaluationDetailsByReader,
        statistics,loadingStatistics,
        settings,loadingSettings,
        mainPermission,loadingMainPermission,
        notifications,loadingNotifications,
        profileDetails,loadingProfileDetails,
        warehouses,loadingWarehouses,
        products,loadingProducts,
        categories,loadingCategories,sub_categories_by_category,
        sub_categories,loadingSubCategories,
        projects,loadingProjects,
        supppliers,loadingSupppliers,
        suppplierss,loadingSuppplierss,
        requests,loadingRequests,
        orders,loadingOrders,
        deliveries,loadingDeliveries,
        zoneType,loadingZoneType,
        zoneWarehouse,loadingZoneWarehouse,
        one_product,loadingOneProduct,
        one_warehouse,loadingOneWarehouses,
        accounts,loadingAccounts,
        transactions,loadingTransactions,
        statements,loadingStatements,
        expenses,loadingExpenses,
        page_list,loadingPageList,
        one_account,loadingOneAccount,
        page_list_transaction,loadingPageListTransaction,
        page_list_statement,loadingPageListStatement,
        one_statement,loadingOneStatement,
        one_expense,loadingOneExpense,
        statementsByAccount,loadingStatementsByAccount,
        dataReport,loadingDataReport,
        page_list_expenses,loadingPageListExpenses,
        page_list_scripts_archive,loadingPageListScriptsArchive,
        scriptsArchive,loadingScriptsArchive,
        oneScriptsArchive,loadingOneScriptsArchive,currency,
        account_types,loadingAccountTypes,user_id,
        accountDetails,
        vcards,loadingVcards,
        zone,loadingZone,loadingProductsByZone,productsByZone
    }
}